export function DarkMode() {
  return {
    mode: "light",

    init() {
      this.getModePreference();
      this.applyPreference();
    },

    saveModePreference() {
      localStorage.setItem("mode", this.mode);
    },

    getModePreference() {
      this.mode = localStorage.getItem("mode") ?? this.getAutoMode();
    },

    switchPreference() {
      if (document.documentElement.dataset.theme === "dark") {
        this.mode = "light";
      } else {
        this.mode = "dark";
      }
      this.saveModePreference();
      this.applyPreference();
    },

    applyPreference() {
      document.documentElement.dataset.theme = this.mode;
    },

    getAutoMode() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    },
  };
}
